const config = window.config || {};

export const env = {
  API_URL: `${window.location.protocol}//${config.API_URL}` || process.env.REACT_APP_API_URL,
  REDATTORE_URL:
    `${window.location.protocol}//${config.REDATTORE_URL}` || process.env.REACT_APP_REDATTORE_URL,
};
